import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const SlidsHome = () => {
  return (
   <>
   <div className="row">
        <div className="col-12">
          
        <div className="m-3">
        <Link className="btn btn-dark m-2" to="./Add">
          <i className="material-icons">add_box</i> | Add a new Slider
        </Link>
      </div>

          <div className="card my-4">
          

            <Outlet /> 
            </div>
            </div>
            </div> 
            </>
  );
};

export default SlidsHome;